import { useState, useEffect } from 'react'; 

export default function useGoogleMaps() {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_GCP_API_KEY}&libraries=places`;
        script.onload =  () => setLoaded(true);
        document.body.appendChild(script);
    }, []);

    return loaded;
}